import React, { useEffect, useState, useMemo, useContext } from 'react';
import { Card, Justify, Button, Modal, PagingQuery } from 'tea-component';
import { useIntl, getLocale, useSelector } from 'umi';
import Filter from '@/pages/intelligence/pages/TopCharts/components/CommonFilter';
import Visualis from '@/pages/intelligence/pages/TopCharts/MobileGames/components/Visualis/ActiveUserVisualis';
import ChartIconType from '@/pages/intelligence/components/ChartsComponents/ChartIconType';
import { ChartType, SortMode } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import { toActiveUsersTag, toActiveUsersTagToCN } from '@/pages/intelligence/utils/common';
import useActiveUserModel from '@/pages/intelligence/pages/TopCharts/MobileGames/hooks/useActiveUserModel';
import Loading from '@/pages/intelligence/components/Loading';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import {
  TableSelectStatusType,
  TableSelectionType,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import ActiveUsersTable from '@/pages/intelligence/pages/TopCharts/MobileGames/components/Tables/ActiveUsersTable';
import {
  ACTIVE_METRICS,
  DATA_SOURCE_NAME_MAP,
  AU_TITLE_MAP,
} from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import { getFilterName, getFilterValueStorage } from '@/pages/intelligence/components/Filter/util';
import ArrowdownText from '@/pages/intelligence/components/ArrowdownText';
import { handleCommonReqParams } from '@intelligence/pages/TopCharts/MobileGames/hooks/serviceHooks';
import { getDbiFilterParams } from '@intelligence/utils/filterUtils';
import type { TopchartFilterCfgType } from '@intelligence/types/topchart';
import TipContext from '@home/components/TipContextComponents/TipContext';
import ExportTable from '@intelligence/components/ExportTable';
import './index.scss';
import { MOBILE_COMPETITOR_TABLE_DOWNLOAD } from '@home/pages/studio/buttonLogConfig';
import { StudioContext } from '@home/pages/studio/context';
import { JumpType, navigate } from '@home/utils/utils';
import { writeShortUrlParams } from '@intelligence/services/common';
import { URL_FILTER_KEY, URL_SHORT_LINK_NAME } from '@intelligence/utils/urlPathCfg';
const GAME_PRIMARY_KEY = 'id';

interface ActiveUsersProp {
  filterCfg: TopchartFilterCfgType;
  topchartsNameParams: string;
  getDeliveryTipValue: string;
  filterLoading: boolean;
  rangeTimeComponentDefault: any;
  defaultParams: object;
}
/** 4 个榜单区别
 *  'activeuser'                      | 'revenue' | 'downloads' | databrain
 * ------------------------------------------------------------------------
 * 有表格首次提示                      |无         |无            |  无
 * 展示下载提示 和 首次进入下载提示     |无         |无            |  无
 * 表格有校准游戏图标提示              |有         |有            | 无
 * 游戏继承,折线接口chart_type = 1    |有          |有           |  游戏不继承
 * 有platform筛选器，参数为选择的值    |有         |有            | 没有platforms筛选器，参数默认['unified']
 */
export default function MobileCompetitorContent(props: ActiveUsersProp) {
  const {
    filterLoading,
    topchartsNameParams,
    filterCfg,
    rangeTimeComponentDefault,
    defaultParams = {},
  } = props;
  const topChartsType = 'activeuser';
  const { currentGame,  } = useContext(StudioContext);
  const { unified_edition_id: gameId, } = currentGame || {};
  const shortLinkValidQuery = { chart_type: 'bar' };
  const urlCustomParams = {};
  const DEFAULT_FORM_VALUE = filterCfg?.defaultValue;
  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const [isError, setIsError] = useState(false);
  const [sortByName, setSortByName] = useState('');
  const [sortByNameCn, setSortByNameCn] = useState('');
  const { userInfo } = useSelector((state: any) => {
    const { userInfo } = state.home;
    return {
      userInfo,
    };
  });
  // const isOperate = filterState?.isOperate;
  // 在筛选器这里拿到缓存的值，并渲染
  const filterSaveName = getFilterName(userInfo);
  const filterSaveData = getFilterValueStorage(userInfo);
  const [filterValue, setFilterVale] = useState(DEFAULT_FORM_VALUE);

  /** ******** 榜单核心逻辑hooks，该hooks内处理了，页面初始化查询、排序、翻页等关联逻辑，begin***************/
  const {
    showFirstGuide,
    tableTotal,
    tableData,
    chartType,
    setChartType,
    barOrPieData,
    setBarOrPieData,
    lineData,
    fetchParams,
    getGameData,
    // getTopChartsMaxDate,
    getLineChartData,
    defaultSelectionGames,
    isNewComfirm,
    setIsNewComfirm,
    isNewCheckGame,
    setIsNewCheckGame,
    tableSelection,
    firstDownLoadBubleShow,
    setFirstDownLoadBubleShow,
    operatedGame,
    setOperatedGame,
    setTableSelection,
    isNodata,
    showNoGameExtendModal,
    setShowNoGameExtendModal,
    handleSortByFront,
  } = useActiveUserModel({
    topChartsType,
    isDataBrain: false,
    defaultParams,
    shortLinkValidQuery,
    filterValue,
    setFilterVale,
    hasUrlShortLink: filterCfg?.hasUrlShortLink,
    defaultSelectGameNum: 6,
    sortByFront: true,
    primaryKey: 'id'
  });
  /** ****** 榜单核心逻辑hooks，该hooks内处理了，页面初始化查询、排序、翻页等关联逻辑 end *******************/
  const [tableLoading, setTableLoading] = useState(true);
  const [isVisualisLoading, setIsVisualisLoading] = useState(true);
  useEffect(() => {
    setTableLoading(true);
    setIsVisualisLoading(true);
    if (!userInfo?.userid || filterLoading) {
      // 拿缓存值需要拿到用户id
      return;
    }
    let newFetchParams = { ...fetchParams };
    const { filterValue: newFilterValues, filterParams } = getDbiFilterParams({
      userInfo,
      urlCustomParams,
      urlShortLinkFilter: null,
      filterSaveData: filterSaveData?.apiValue,
      filterExtend: {},
      specialParams: filterCfg?.specialParams,
      isOperate: false,
      filterName: filterSaveName,
      filterKeyList: filterCfg?.filterKeyList ?? Object.keys(DEFAULT_FORM_VALUE),
    });

    const newFilterValuesTemp = {
      ...DEFAULT_FORM_VALUE,
      ...newFilterValues,
    };
    setFilterVale(newFilterValuesTemp);
    newFetchParams = {
      ...newFetchParams,
      ...(urlCustomParams || {}),
      ...filterCfg?.handleFilterToApiParams?.(filterParams),
    };
    getData({
      params: newFetchParams,
      isCheckGame: operatedGame,
      isSearch: false,
      isUpdateLineChart: true,
      updateFilterValues: newFilterValuesTemp,
    });
    // }
  }, [userInfo?.userid, filterLoading]);

  const getData = (args: {
    params: any;
    isCheckGame: boolean;
    isSearch?: boolean;
    isUpdateLineChart: boolean;
    updateFilterValues?: any;
    myFilterValue?: string;
  }) => {
    const {
      params,
      isCheckGame,
      isSearch = false,
      isUpdateLineChart = true,
      updateFilterValues = filterValue,
      myFilterValue = filterSaveName,
    } = args;
    getGameData({
      params: {
        ...params,
        game_code: isSearch ? params?.game_code : [],
        topcharts_name: topchartsNameParams,
      },
      isCheckOrSearch: isCheckGame,
      isUpdateLineChart,
      updateFilterValues,
      filterSaveName: myFilterValue,
    })
      .then(() => {
        setTableLoading(false);
        setIsVisualisLoading(false);
      })
      .catch(() => {
        setTableLoading(false);
        setIsVisualisLoading(false);
        setIsError(true);
      });
  };

  const getTrend = (params: any, idList: string[]) => {
    setIsVisualisLoading(true);
    getLineChartData(params, idList)
      .then(() => {
        setIsVisualisLoading(false);
      })
      .catch(() => {
        setIsVisualisLoading(false);
        setIsError(true);
      });
  };

  const handleConfirm = async (value: any, filter: any, myFilterValue: any) => {
    const newFormValue = {
      ...fetchParams,
      ...value,
      page: 1,
      // page_size: 100,
      page_size: 50,
    };
    // 请求接口
    setTableLoading(true);
    setIsVisualisLoading(true);
    /** 修改筛选器后，游戏应该重置为未勾选状态 */
    setOperatedGame(false);
    const filterIds = newFormValue?.filter_ids;
    if(!filterIds?.includes(gameId)) {
      filterIds.push(gameId);
    }
    getData({
      params: {...newFormValue, filter_ids: filterIds},
      isCheckGame: false,
      isSearch: false,
      isUpdateLineChart: true,
      updateFilterValues: filter,
      myFilterValue,
    });

    setIsNewComfirm(true);
    setIsNewCheckGame(true);
  };
  // 切换charts类型事件
  const handleChartType = (value: ChartType) => {
    if (value === ChartType.Line && tableSelection?.length && isNewComfirm && isNewCheckGame) {
      const idList = tableSelection.map((t) => t?.gameId);
      getTrend(fetchParams, idList);
    }
    setChartType(value);
  };

  const handleSortByFetchApi = async (newFetchParams: any, sortFun: Function) => {
    // if (!operatedGame) {
    //   /** 没有勾选时点排序则重新Loading柱状图数据 */
    //   setIsVisualisLoading(true);
    // }
    await sortFun?.({
      list: tableData,
      params: newFetchParams,
      isCheckGame: operatedGame,
      isSearch: false,
      isUpdateLineChart: !operatedGame,
    });
  };

  const onTableSortChage = async (e: SortByItemType) => {
    const newFetchParams = {
      ...fetchParams,
      order: e?.sortVal,
      order_metric: e?.sortMetric,
      order_source: e?.orderSource,
      ratio_type: e?.ratioType,
      page: 1,
      // page_size: 100,
      page_size: 50,
    };
    setTableLoading(true);
    setSortByName(e?.title_en || '');
    setSortByNameCn(e?.title_cn || '');
    // if (!operatedGame) {
    //   /** 没有勾选时点排序则重新Loading柱状图数据 */
    //   setIsVisualisLoading(true);
    // }
    await handleSortByFetchApi(newFetchParams, handleSortByFront);
    setTableLoading(false);

    // setMetric(defaultMetric.length > 0 ? defaultMetric[0].value : '');
  };

  const onTablePagingChange = (e: PagingQuery) => {
    const newFetchParams = {
      ...fetchParams,
      page: e?.pageIndex || 1,
      // page_size: e?.pageSize || 100,
      page_size: e?.pageSize || 50,
    };
    setTableLoading(true);
    getData({
      params: newFetchParams,
      isCheckGame: operatedGame,
      isSearch: false,
      isUpdateLineChart: false,
    });
  };

  // 表格列表项选择事件回调
  const onTableCheckGame = (
    selectList: TableSelectionType[],
    checkStatus: TableSelectStatusType,
  ) => {
    setIsNewComfirm(true);
    setIsNewCheckGame(true);

    const idList = selectList.map((t) => t?.gameId);
    if (chartType === ChartType.Line) {
      getTrend(fetchParams, idList);
    }
    if (checkStatus === 'cancel' || checkStatus === 'all' || selectList.length === 0) {
      setOperatedGame(false);
    } else {
      setOperatedGame(true);
    }
    setBarOrPieData(selectList);
    setTableSelection(selectList);
  };

  const titleNow = useMemo(() => {
    const orderMetricName =
      (locale === LANGUAGE_CN
        ? toActiveUsersTagToCN[fetchParams?.date_type]
        : toActiveUsersTag[fetchParams?.date_type]) || '';
    return orderMetricName;
  }, [fetchParams?.date_type, fetchParams?.order_metric, locale]);

  const handleReset = () => {
    setOperatedGame(false);
  };

  useEffect(() => {
    if (showNoGameExtendModal) {
      errTip();
      setShowNoGameExtendModal(false);
    }
  }, [showNoGameExtendModal]);

  const errTip = () => {
    Modal.error({
      size: 'm',
      message: 'Notice',
      description: (
        <>
          <p>{formatMessage({ id: 'dbi_gameselected_err_info' })} </p>
          <p>{formatMessage({ id: 'dbi_gameselected_reset_info' })}</p>
        </>
      ),
      buttons: [
        <Button key="btn" type="primary">
          {formatMessage({ id: 'dbi_confirm' })}
        </Button>,
      ],
    });
  };
  const titleNowValue = useMemo(() => {
    if (sortByName && sortByNameCn) {
      return locale === 'zh-CN' ? sortByNameCn : sortByName;
    }
    return titleNow;
  }, [sortByName, titleNow, sortByNameCn, locale]);

  // 根据排序获得Sorted by 标题
  const orderNameInfo = useMemo(() => {
    if (!fetchParams) return '';
    const {
      order_source: orderSource,
      // order_metric: orderMetric,
      ratio_type: ratioType,
    } = fetchParams;
    const orderMetricObj = ACTIVE_METRICS.find((item) => item.value === fetchParams.order_metric);
    const orderMetricName = orderMetricObj?.label || AU_TITLE_MAP?.[fetchParams?.date_type] || '';
    const orderSourceName = DATA_SOURCE_NAME_MAP[orderSource] || '';
    const result = `${orderSourceName} ${orderMetricName}`;
    return ratioType === SortMode.Circle
      ? `${result}(${orderSource == 'sensortower' ? '$' : '%'})`
      : result;
  }, [
    titleNowValue,
    fetchParams?.order_source,
    fetchParams?.order_metric,
    fetchParams?.ratio_type,
    fetchParams?.date_type,
    titleNow,
  ]);

  const onClick = async (url: string) => {
    try {
      const result = await writeShortUrlParams({
        system_type: 'intelligence',
        params: JSON.stringify({ [URL_FILTER_KEY]: filterValue }),
      });

      const shortLinkId = result?.data?.key;

      navigate(
        shortLinkId ? `${url}?${URL_SHORT_LINK_NAME}=${shortLinkId}` : url,
        { jumpType: JumpType.Window },
      );
      return;
    } catch (error) {
      console.error('Short link generate failed:', error);
    }

    navigate(url, { jumpType: JumpType.Window });
  };

  return (
    <>
      <Card>
        <Card.Body className="dbh-studio-mobileGames-filter-wrap">
          <Filter
            filterConfirm={handleConfirm}
            filterReset={handleReset}
            filterValue={filterValue}
            setFilterVale={setFilterVale}
            defaultValue={DEFAULT_FORM_VALUE}
            filterCfg={filterCfg}
            rangeTimeComponentDefault={rangeTimeComponentDefault}
          />
        </Card.Body>
      </Card>

      <Card className="dbi-mobileGames-card-context">
        <Card.Body
          title={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: 5 }}>{titleNow}</span>
              <TipContext
                AWidth={600}
                tipText={formatMessage({
                  id: `dbi_info_following_mobile_title`,
                })}
              />
              <span style={{ marginRight: 5 }}></span>
              <ArrowdownText isNew={true} sortedData={orderNameInfo} order={fetchParams?.order} />
            </div>
          }
          operation={
            tableLoading ? null : (
              <ChartIconType chartType={chartType} handleChartType={handleChartType} />
            )
          }
        >
          {isVisualisLoading ? (
            // 426-76
            <div style={{ height: 350 }}>
              <Loading />
            </div>
          ) : (
            <Visualis
              entityType={fetchParams?.entity_type}
              primaryKey={GAME_PRIMARY_KEY}
              dataSources={fetchParams?.data_sources}
              chartType={chartType}
              dateType={fetchParams?.date_type}
              fetchParams={fetchParams}
              sourceOrders={fetchParams?.data_sources}
              barOrPieData={barOrPieData}
              lineData={lineData}
              isVisualisLoading={isVisualisLoading}
              isError={isError}
              isNodata={isNodata}
              orderTypeInfo={fetchParams?.order}
              isDataBrain={false}
              titleNow={titleNow}
              topChartsType={topChartsType}
              imageType={'mobile'}
              sortByName={sortByName}
              sortByNameCn={sortByNameCn}
              gameHighId={gameId}
              isStudio={true}
            />
          )}
        </Card.Body>
      </Card>

      <Justify
        className="dbh-studio-mobileGames-card-justify"
        right={
          <>
            <ExportTable
              stickText={formatMessage({ id: 'dbi_mobile_download_modal_stick_tips' })}
              downloadModalSize={820}
              entityType="mobile"
              businessType={'mobile-activeuser-studio'}
              isDisableDownload={tableLoading}
              isAllAndChecked={true}
              total={tableTotal}
              // isOnlyExportAllData={true}
              tableParams={{ ...handleCommonReqParams(fetchParams), select_ids: tableSelection }}
              isNeedCheckedLines={true}
              defaultCheckedLines={operatedGame}
              isGameTopCharts={true}
              hasBubbleCloseIcon={firstDownLoadBubleShow}
              onBubbleClose={() => {
                setFirstDownLoadBubleShow(false);
                /** 下载首次提示关闭打点 */
                buriedBtnPoint({
                  ...MOBILE_COMPETITOR_TABLE_DOWNLOAD,
                  gameName: currentGame?.game_name,
                });
              }}
            />
          </>
        }
      />
      <CardSlot className='dbh-studio-mobileGames-table-slot dbh-studio-mobileGames-table'>
        <ActiveUsersTable
          entityType={fetchParams?.entity_type}
          showFirstGuide={showFirstGuide}
          records={tableData}
          loading={tableLoading}
          tableTotal={tableTotal}
          tableSelection={tableSelection}
          tableSelectionAll={defaultSelectionGames}
          pageSortAttr={{
            tablePageIndex: fetchParams?.page,
            tablePageSize: fetchParams?.page_size,
            currentSortValue: fetchParams?.order,
            currentSortMetric: fetchParams?.order_metric,
            currentOrderSource: fetchParams?.order_source,
            currentRatioType: fetchParams?.ratio_type,
          }}
          onTableSortChage={onTableSortChage}
          onTablePagingChange={onTablePagingChange}
          onTableCheckGame={onTableCheckGame}
          selectDataSources={fetchParams?.data_sources}
          topChartsType={topChartsType}
          dateType={fetchParams?.date_type}
          genreSource={fetchParams?.genre_source ?? 'annie'} // iegg时，genre_source有值
          onClick={onClick}
        />
      </CardSlot>
    </>
  );
}
